// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2023project/q2/2023chongqing_cup/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
    },
  });
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getUserInfo = (unionid: any) => {
  return http.get(`${urlPrefix}user-info`, {
    params: {
      unionid,
    },
  });
}

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const register = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};

export { getBaseInfo, getVoteList, getRule, getDetail, register, getUserInfo, getNews };
